import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import StandarizedEquipment from "./StandarizedEquipment";
import RequisitionAction from '../../../../../../../Store/Component/Requisition/RequisitionAction'

const StandarizedEquipmentContainer = (props:any) => {
const dispatch = useDispatch();
const managedEquipRef = props?.managedEquipRef
const [manufacturerDropDownList, setManufacturerDropDownList] = useState<any>([]);
const [categoryDropdownList, setCategoryDropdownList] = useState<any>([]);

const {managedEquipmentDropDown, managedEquipmentValues, isEditRequestClick, editRequestDetails }: any = useSelector((state? : any) => ({
  managedEquipmentDropDown: state.ManagedEquipmentDropDownReducer.managedEquipmentDropDown,
  managedEquipmentValues: state.RequisitionReducer.managedEquipmentValues,
  editRequestDetails: state.RequisitionReducer.editRequestDetails,
  isEditRequestClick: state.RequisitionReducer.isEditRequestClick,
}));

  ///Modified dropDown values as required
  useEffect(()=>{
    if (managedEquipmentDropDown?.length > 0) {
      managedEquipmentDropDown?.map((item: any) => {
        if (item?.dropdownName == "Manufacturer") {
          const defaultManufacturerOption = {
            text: "Select Manufacturer",
            value: null
        };
        item?.dropdownList?.unshift(defaultManufacturerOption);
          let manufacturerDropdownListTemp = item?.dropdownList?.map((val: any) =>
            ({ text: val.text, value: val.value, label: val.text, key: val.value })
          );
          setManufacturerDropDownList(manufacturerDropdownListTemp)
        } else if (item?.dropdownName == "Category") {
          const defaultCategoryOption = {
            text: "Select Category",
            value: null
        };
        item?.dropdownList?.unshift(defaultCategoryOption);
        let categoryDropdownListTemp = item?.dropdownList?.map((val: any) =>
            ({ text: val.text, value: val.value, label: val.text, key: val.value })
          );
          setCategoryDropdownList(categoryDropdownListTemp)
        }
      })
    }
  },[managedEquipmentDropDown])

  useEffect(() => {
    if (isEditRequestClick) {
      let managedEquipmentValuesTemp: any = {}
      let selectedManufacturer: any = ""
      let selectedCategory: any = ""
      if (editRequestDetails?.manufacturer && manufacturerDropDownList?.length > 0) {
        selectedManufacturer = manufacturerDropDownList?.find((manufacturer: any) => manufacturer?.value === editRequestDetails?.manufacturer)
      }

      if (editRequestDetails?.category && categoryDropdownList?.length > 0) {
        selectedCategory = categoryDropdownList?.find((category: any) => category?.value === editRequestDetails?.category)
      }
      managedEquipmentValuesTemp = { ...managedEquipmentValues, manufacturer: selectedManufacturer, category: selectedCategory }
      dispatch(RequisitionAction.setManagedEquipmentValues(managedEquipmentValuesTemp))
    }
  }, [isEditRequestClick, manufacturerDropDownList, categoryDropdownList])

  useEffect(()=> {
    props.managedEquipRef.current[1]?.focus()
  },[])

  const handleCategoryChange = (e:any,item:any,name:string) => {
    dispatch(RequisitionAction.setManagedEquipmentValues({
      ...managedEquipmentValues,
      [name]: item
  }));
    if(item.label != 'Select Category') {
        props.managedEquipRef.current[2]?.focus()
    }
  }

  const handleManufacturerChange = (e:any,item:any,name:string) => {
    dispatch(RequisitionAction.setManagedEquipmentValues({
      ...managedEquipmentValues,
      [name]: item
  }));
    if(item.label != 'Select Manufacturer') {
        props.managedEquipRef.current[8]?.focus()
    }
  }
return (
    <StandarizedEquipment
        managedEquipmentValues={managedEquipmentValues}
        categoryDropdownList={categoryDropdownList}
        manufacturerDropDownList={manufacturerDropDownList}
        managedEquipRef={managedEquipRef}
        handleCategoryChange={handleCategoryChange}
        handleManufacturerChange={handleManufacturerChange}
    />
)
}

export default StandarizedEquipmentContainer;
